/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { RenderConditionFromJSON, RenderConditionToJSON } from './RenderCondition';
import { CreateBlockFromJSON, CreateBlockToJSON } from './CreateBlock';
import { ResourceAuthorizationRuleFromJSON, ResourceAuthorizationRuleToJSON } from './ResourceAuthorizationRule';

/**
 * 
 * @export
 * @interface CreateZone
 */

/**
 * Check if a given object implements the CreateZone interface.
 */
export function instanceOfCreateZone(value) {
  if (!('zoneType' in value) || value['zoneType'] === undefined) return false;
  return true;
}
export function CreateZoneFromJSON(json) {
  return CreateZoneFromJSONTyped(json, false);
}
export function CreateZoneFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'zoneRID': json['zoneRID'] == null ? undefined : json['zoneRID'],
    'id': json['id'] == null ? undefined : json['id'],
    'zoneParameters': json['zoneParameters'] == null ? undefined : json['zoneParameters'],
    'zoneType': json['zoneType'],
    'blocks': json['blocks'] == null ? undefined : json['blocks'].map(CreateBlockFromJSON),
    'condition': json['condition'] == null ? undefined : RenderConditionFromJSON(json['condition']),
    'foreach': json['foreach'] == null ? undefined : json['foreach'],
    'as': json['as'] == null ? undefined : json['as'],
    'authorize': json['authorize'] == null ? undefined : json['authorize'].map(ResourceAuthorizationRuleFromJSON)
  };
}
export function CreateZoneToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'zoneRID': value['zoneRID'],
    'id': value['id'],
    'zoneParameters': value['zoneParameters'],
    'zoneType': value['zoneType'],
    'blocks': value['blocks'] == null ? undefined : value['blocks'].map(CreateBlockToJSON),
    'condition': RenderConditionToJSON(value['condition']),
    'foreach': value['foreach'],
    'as': value['as'],
    'authorize': value['authorize'] == null ? undefined : value['authorize'].map(ResourceAuthorizationRuleToJSON)
  };
}